import React, { Component } from 'react';
import './App.css';
import { Navigate, Route, Routes, useNavigate } from "react-router-dom";
import { IFilter, IMe, IProduct } from './types';
import Home from './Components/Home';
import Farms from './Components/Farms';
import ReviewFarms from './Components/ReviewFarms';
import ReviewPedidos from './Components/ReviewPedidos';
import ReviewPedidoDetail from './Components/ReviewPedidoDetail';
import Products from './Components/Products';
import FarmDetail from './Components/FarmDetail';
import OutOfService from './Components/OutOfService';
import Unauthorized from './Components/Unauthorized';
import OrderService from './ApiClients/OrderService';
import Pedidos from './Components/Pedidos';
import Retiradas from './Components/Retiradas';
import PedidoDetail from './Components/PedidoDetail';
import { cloneDeep } from 'lodash';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import Cesta from './Components/Cesta';
import ProductDetail from './Components/ProductDetail';
import appData from './ApiClients/appData';
import { withParamsAndNavigate } from './Components/Material/ReactRouter';

let timerGetData:any = undefined;

const { version } = require('../package.json');
const appVersion = `v${version}`;


const i_filters:IFilter = {f_do: {}, f_farms: {}, f_products: {}, f_retiradas: {}};

interface IAppProps {
  params?:any;
  navigate?:any; 
}

interface IAppState {
  myInfo?: IMe;
  cart: Array<IProduct>;
  otherProductFarm: boolean;
  cartFarmRef?: string;
  cartBusiness?:string;
  idPedido?:number;
  cartDate?: MaterialUiPickersDate;
  cartComments: string;
  defaultDeliveryTruckNumberplate?: string;
  defaultDeliveryTrailerNumberplate?: string;
  filters: IFilter;
}

class App extends Component<IAppProps, IAppState> {
  constructor(props: IAppProps) {
    super(props);
    this.state = {
      filters: i_filters,
      myInfo: undefined,
      cart:[],
      otherProductFarm: false,
      cartFarmRef: undefined,
      cartBusiness: undefined,
      cartDate: undefined, 
      idPedido: undefined,
      cartComments: '',   
    };
  }

  componentWillMount(){


    this.getMyInfo();
    OrderService.metricService(1); // Guarda el registro del primer Login
  }

  componentDidMount(){
    timerGetData = setInterval(this.refreshData, 300000);
  }

  handleChangeFilter = (id:string, filters:any) => {
    let f = cloneDeep(this.state.filters);
    f[id] = filters;
    this.setState({filters: f});
  }

  refreshData = async () => {
    clearInterval(timerGetData);

    OrderService.getFarms(true);
    OrderService.getPedidos(true, 1); // Type 1 - Pedidos
    OrderService.getPedidos(true, 2); // Type 2 - Delivery

    timerGetData = setInterval(this.refreshData, 300000);
  }

  metrics = async (metricType:number) => { // Registra el acceso del usuario, el fallo no autorizado y el fallo por mantenimiento
    await OrderService.metricService(metricType);
  }

  getMyInfo = async () => {
    let response = await OrderService.me();
    //this.setState({ myInfo:response });
    this.checkUserPermission(response);
  }
    
  checkUserPermission=(inputInfo:IMe)=>{ // Verifica los permisos del usuario //
    if(inputInfo !== null) {
      if(!inputInfo.authorized) { // Actualiza el estado MyInfo en caso de haber obtenido correctamente la información del usuario
        this.setState({ myInfo: undefined });
        this.props.navigate('/noAutorizado');
        this.metrics(2);
      } else if(!inputInfo.activated) {
          this.props.navigate('/fueraServicio');
          this.metrics(3);
      } else {
        this.setState({ myInfo: inputInfo });
      }
    } else if(inputInfo == undefined){
      this.props.navigate('/noAutorizado');
      this.metrics(2);
    } else {
      this.props.navigate('/noAutorizado');
    }
  }

  addOrRemoveFromCart = (product: IProduct, farmRef: string, business:string) => {
    if ((this.state.cart.length !== 0 && farmRef !== this.state.cartFarmRef) || (this.state.cart.length !== 0 && business !== this.state.cartBusiness)) {
      this.setState({
        otherProductFarm: true
      })
      return;
    }

    let newCart: Array<IProduct> = cloneDeep(this.state.cart);

    let isInCart = newCart.find((item) => {
      return (item.itemId + item.business + item.feedStage + item.batchId) === (product.itemId + product.business + product.feedStage + product.batchId);
    }) !== undefined ? true : false;

    if (isInCart) {
      product.isInCart = false;
      product.silos = [];
      product.quantity = undefined;
      newCart = newCart.filter((item) => {
        return (item.itemId + item.business + item.feedStage + item.batchId) !== (product.itemId + product.business + product.feedStage + product.batchId);
      })
    } else {
      product.isInCart = true;
      newCart.push(product);
    }

    this.setState((prevState, props) =>({
      cart: newCart,
      cartBusiness: business,
      cartFarmRef: farmRef,
      idPedido: farmRef !== prevState.cartFarmRef?undefined:prevState.idPedido,
      cartDate: farmRef !== prevState.cartFarmRef?undefined:prevState.cartDate
    }))
  }

  recreateCart = (products: Array<IProduct>, farmRef: string, id: number, date:string) => {
    this.setState({ 
      cart: products,
      cartFarmRef: farmRef,
      idPedido: id,
      cartDate: new Date(date)
    })
  }

  updateCart = (product: IProduct, changeQty?:boolean) => {
    let isInCart = this.state.cart.find((item) => {
      return (item.itemId + item.business + item.feedStage + item.batchId) === (product.itemId + product.business + product.feedStage + product.batchId);
    }) !== undefined ? true : false;
    
    if (isInCart === true) {

      let newCart: Array<IProduct> = cloneDeep(this.state.cart);
      newCart = newCart.map((item) => {

        if ((item.itemId + item.business + item.feedStage + item.batchId) === (product.itemId + product.business + product.feedStage + product.batchId)) {
          if(changeQty){
            item.quantity = product.quantity;
            return item;
          } else {
            return product;
          }
        }
        return item;

      });
      //console.log('newCart', newCart)
      this.setState({ cart: newCart })
    }
  }

  updateQuantityCart = (newCart: Array<IProduct>) => {
      this.setState({ cart: newCart })
  }

  updateCartDate = (date: MaterialUiPickersDate, value?: string | null | undefined) => {
    this.setState({ cartDate: date })
  }

  updateCartComments = (evt: any) => {
    this.setState({ cartComments: evt.target.value });
  }

  resetCart = () => {
    // Reset Silos del producto, pero mejor cambiar al producto del carrito y dejar la lista de productes "virgen"
    let newProducts:Array<IProduct> = appData.getListProducts();
    newProducts.map(item=>{
      return({
        ...item,
        silos:[]
      })
    })
    appData.setListProducts(newProducts);

    this.setState({
      cart:[],
      cartDate:undefined,
      cartFarmRef: undefined,
      cartBusiness: undefined,
      otherProductFarm: false,
      cartComments:''
    })
  }

  resetOtherFarmParameter = () => {
    this.setState({
      otherProductFarm: false
    })
  }

  render() {
    return (
      <Routes>
        <Route
          path="/"
          element={
            <Home
              version={appVersion}
              cart={this.state.cart}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
        path="/granjas"
        element={
          <Farms
            myInfo={this.state.myInfo}
            filters={this.state.filters}
            handleChangeFilter={this.handleChangeFilter}
          />
          }
        />
        <Route
          path="/granja/:business/:farmRef"
          element={
            <FarmDetail
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/granja/:business/:farmRef/productos"
          element={
            <Products
              cart={this.state.cart}
              cartFarmRef={this.state.cartFarmRef}
              cartBusiness={this.state.cartBusiness}
              updateCart={this.updateCart}
              addOrRemoveFromCart={this.addOrRemoveFromCart}
              otherProductFarm={this.state.otherProductFarm}
              resetOtherFarmParameter={this.resetOtherFarmParameter}
              filters={this.state.filters}
              handleChangeFilter={this.handleChangeFilter}
            />
          }
        />
        <Route
          path="/cesta"
          element={
            <Cesta
              cart={this.state.cart}
              farmRef={this.state.cartFarmRef}
              business={this.state.cartBusiness}
              addOrRemoveFromCart={this.addOrRemoveFromCart}
              updateCart={this.updateCart}
              cartDate={this.state.cartDate}
              idPedido={this.state.idPedido}
              updateCartDate={this.updateCartDate}
              cartComments={this.state.cartComments}
              updateCartComments={this.updateCartComments}
              resetCart={this.resetCart}
              updateQuantityCart={this.updateQuantityCart}
            />
          }
        />
        <Route
          path="/granja/:business/:farmRef/producto/:productRef"
          element={
            <ProductDetail
            />
          }
        />
        <Route
          path="/noAutorizado"
          element={
            <Unauthorized
              refreshMyInfo={this.getMyInfo}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/fueraServicio"
          element={
            <OutOfService
              refreshMyInfo={this.getMyInfo}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/pedidos"
          element={
            <Pedidos
              type={1}
              title='Pedidos'
              filters={this.state.filters}
              handleChangeFilter={this.handleChangeFilter}
            />
          }
        />
        <Route
          path="/delivery"
          element={
            <Pedidos
              type={2}
              title='Ruta pedidos'
              filters={this.state.filters}
              handleChangeFilter={this.handleChangeFilter}
            />
          }
        />
        <Route
          path="/retiradas"
          element={
            <Retiradas
              title='Retiradas'
              filters={this.state.filters}
              handleChangeFilter={this.handleChangeFilter}
            />
          }
        />
        <Route
          path="/retirada/:business/:pedidoRef"
          element={
            <PedidoDetail
              updateCart={this.recreateCart}
              resetCart={this.resetCart}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/pedidos/:business/:farmRef"
          element={
            <ReviewPedidos
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/pedido/:business/:pedidoRef"
          element={
            <PedidoDetail
              updateCart={this.recreateCart}
              resetCart={this.resetCart}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/delivery/:business/:pedidoRef"
          element={
            <PedidoDetail
              updateCart={this.recreateCart}
              resetCart={this.resetCart}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/pedidos/:business/:farmRef/:pedidoRef"
          element={
            <ReviewPedidoDetail
              updateCart={this.recreateCart}
              resetCart={this.resetCart}
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="/reviewFarms"
          element={
            <ReviewFarms
              myInfo={this.state.myInfo}
            />
          }
        />
        <Route
          path="*"
          element={<Navigate to="/" replace />}
        />      
      </Routes>
    );
  }
}

export default withParamsAndNavigate(App);